import { type DeepPartial } from '@direct-frontend/stdlib';
import { EMPTY_DASH } from '#shared/lib/constants';
import { type PromoactionModel } from './types';

export const getPromoactionMaxDiscountAmountText = (promoaction: DeepPartial<PromoactionModel>): string => {
    const maxDiscountAmount = promoaction.discount?.max_discount_amount;

    if (!maxDiscountAmount) {
        return EMPTY_DASH;
    }

    return maxDiscountAmount;
};
